import { QueryClient } from '@tanstack/react-query'

/**
 * React Query client with app-wide defaults.
 * Used by app/providers.tsx.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})
